import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { Shop } from './pages/Shop';
import { Category } from './pages/Category';
import { ProductDetail } from './pages/ProductDetail';
import { Contact } from './pages/Contact';
import { FAQ } from './pages/FAQ';
import { InstallationDemos } from './pages/InstallationDemos';
import { Guides } from './pages/Guides';
// Fallback for 404s
const NotFound = () => <div className="min-h-[60vh] flex flex-col items-center justify-center p-8 text-center bg-gray-50" data-id="element-0">
    <h1 className="text-4xl font-bold text-yarbo-dark mb-4" data-id="element-1">
      404 - Page Not Found
    </h1>
    <p className="text-gray-500 max-w-md mb-8" data-id="element-2">
      The page you are looking for doesn't exist or has been moved.
    </p>
    <a href="/" className="btn-secondary" data-id="element-3">
      Return Home
    </a>
  </div>;
export function App() {
  return <BrowserRouter data-id="element-4">
      <Routes data-id="element-5">
        <Route path="/" element={<Layout data-id="element-7" />} data-id="element-6">
          <Route index element={<Home data-id="element-9" />} data-id="element-8" />
          <Route path="shop" element={<Shop data-id="element-11" />} data-id="element-10" />
          <Route path="category/:slug" element={<Category data-id="element-13" />} data-id="element-12" />
          <Route path="product/:slug" element={<ProductDetail data-id="element-15" />} data-id="element-14" />
          <Route path="contact" element={<Contact data-id="element-17" />} data-id="element-16" />
          <Route path="faq" element={<FAQ data-id="element-19" />} data-id="element-18" />
          <Route path="installation-demos" element={<InstallationDemos data-id="element-21" />} data-id="element-20" />
          <Route path="guides" element={<Guides data-id="element-23" />} data-id="element-22" />

          <Route path="*" element={<NotFound data-id="element-25" />} data-id="element-24" />
        </Route>
      </Routes>
    </BrowserRouter>;
}